import { PaginatedResponse } from '../types';

export const BUILDINGS_LIST_PAGE_SIZE = 25;
export const BUILDINGS_SELECTOR_FETCH_LIMIT = 100;

export type BuildingsListResponse = PaginatedResponse<unknown> | unknown[];

export function isPaginatedBuildingsResponse(
  payload: unknown,
): payload is PaginatedResponse<unknown> {
  return (
    !!payload &&
    typeof payload === 'object' &&
    !Array.isArray(payload) &&
    Array.isArray((payload as PaginatedResponse<unknown>).data)
  );
}

export function unwrapBuildingsList(payload: BuildingsListResponse): unknown[] {
  if (Array.isArray(payload)) {
    return payload;
  }
  return payload?.data ?? [];
}

export function unwrapBuildingsMeta(payload: BuildingsListResponse) {
  if (Array.isArray(payload)) {
    return {
      total: payload.length,
      page: 1,
      limit: payload.length,
      totalPages: 1,
    };
  }
  return payload.meta;
}
